<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div key="info" class="title">Cadastro de Produto</div>
        <div @click="$router.push('/product')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <Selector v-model="active" :options="activeOptions" class="selector_change"/>

        <!-- Plataforma -->
        <label>Plataforma</label>
        <select v-model="platform" class="platform-select" :disabled="id !== 'new'">
          <option value="">Selecione a plataforma</option>
          <option value="profit">Profit</option>
          <option value="blackarrow">BlackArrow</option>
          <option value="ninjatrader">NinjaTrader</option>
          <option value="tradingview">TradingView</option>
          <option value="profit_yan">Profit Yan</option>
          <option value="blackarrow_yan">BlackArrow Yan</option>
          <option value="ninjatrader_yan">NinjaTrader Yan</option>
        </select>
        <div v-if="error.includes('platform')" class="hint">selecione a plataforma</div>
        <div v-if="error.includes('platform_duplicate')" class="hint">já existe um produto com esta plataforma</div>

        <!-- Descrição (opcional) -->
        <label>Descrição (opcional)</label>
        <textarea v-model="desc" rows="2" placeholder="Ex: Assinatura mensal recorrente" />

        <!-- Períodos do Plano -->
        <label>Períodos do Plano</label>
        <div class="periods-list-scroll">
          <div class="periods-list">
            <div v-for="(period, index) in periods" :key="index" class="period-block">
            <div class="period-row period-row-desc">
              <input
                v-model="period.periodName"
                type="text"
                placeholder="Ex: Mensal, Trimestral, Anual"
                class="period-name"
                :class="{ error: periodError(index, 'periodName') }"
              />
              <input
                v-model.number="period.dias"
                type="number"
                min="1"
                placeholder="Dias *"
                class="period-dias"
                :class="{ error: periodError(index, 'dias') }"
                title="Quantidade de dias do período (obrigatório)"
              />
            </div>
            <div class="period-row">
              <input
                v-model="period.description"
                type="text"
                placeholder="Descrição do período (opcional)"
                class="period-desc"
              />
            </div>
            <div class="period-row period-row-values">
              <div class="period-price-wrapper">
                <label class="period-currency-label">R$</label>
                <money
                  v-bind="formatMoney"
                  v-model="period.price"
                  :class="{ error: periodError(index, 'price') }"
                  class="period-price"
                />
              </div>
              <div class="period-price-wrapper">
                <label class="period-currency-label">US$</label>
                <money
                  v-bind="formatMoneyUsd"
                  v-model="period.priceUsd"
                  :class="{ error: periodError(index, 'priceUsd') }"
                  class="period-price"
                />
              </div>
              <button
                v-if="periods.length > 1"
                type="button"
                class="period-remove"
                @click="removePeriod(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
            <div class="period-row period-row-second-discount">
              <label class="period-field-label">Desconto 2ª assinatura (%)</label>
              <input
                v-model.number="period.secondSubscriptionDiscount"
                type="number"
                min="0"
                max="100"
                step="1"
                placeholder="0 a 100"
                class="period-second-discount"
                :class="{ error: periodError(index, 'secondSubscriptionDiscount') }"
                title="Desconto aplicado quando o cliente já possui outra assinatura ativa"
              />
            </div>
            <!-- Promoção do período -->
            <div class="period-promotion">
              <label class="switch switch-sm">
                <input v-model="period.promotion" type="checkbox">
                <span class="slider"></span>
                <span class="text">{{ period.promotion ? 'Promoção' : 'Sem promoção' }}</span>
              </label>
              <div v-if="period.promotion" class="period-promotion-fields">
                <select v-model="period.type" @change="setPeriodFormat(index)">
                  <option value="percent">Desconto %</option>
                  <!--<option value="fixed">Valor fixo</option>-->
                </select>
                <money
                  :key="`discount-${index}-${period.type}`"
                  v-bind="getFormatMoney2(index)"
                  v-model="period.discount"
                  :class="{ error: periodPromotionError(index, 'discount') }"
                  class="discount-input"
                />
                <input
                  v-model="period.expiration"
                  v-on:keydown="validade"
                  type="date"
                  placeholder="Validade"
                  :min="(new Date()).toISOString().split('T')[0]"
                  :class="{ error: periodPromotionError(index, 'expiration') }"
                  class="expiration-input"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
        <button v-if="id === 'new' || editFull" type="button" class="add-period-btn" @click="addPeriod">
          <i class="fas fa-plus"></i> Adicionar período
        </button>
        <div v-if="error.includes('periods')" class="hint">adicione pelo menos um período com nome, dias e valores (R$ ou US$)</div>
      </form>
      <div class="actions">
        <button @click="$router.push('/product')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
        <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { create, update, remove, addPeriod, getProductById, getProductGroupedById } from '../api/product'
import Selector from './Selector'

const PLATFORM_LABELS = {
  profit: 'Profit',
  blackarrow: 'BlackArrow',
  ninjatrader: 'NinjaTrader',
  tradingview: 'TradingView',
  profit_yan: 'Profit Yan',
  blackarrow_yan: 'BlackArrow Yan',
  ninjatrader_yan: 'NinjaTrader Yan'
}

export default {
  name: 'product',
  components: { Selector },
  props: ['id', 'productData', 'editFull'],
  data () {
    return {
      loading: false,
      error: [],
      platform: '',
      desc: null,
      active: null,
      periods: [
        { periodName: '', dias: null, description: '', price: '', priceUsd: '', secondSubscriptionDiscount: 0, promotion: false, type: 'percent', discount: null, expiration: null }
      ],
      initialPeriodIds: [],
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      formatMoneyUsd: {
        decimal: '.',
        thousands: ',',
        prefix: 'US$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      activeOptions: [
        { value: true, text: 'ATIVO' },
        { value: false, text: 'INATIVO' }
      ]
    }
  },
  watch: {
    productData (val) {
      if (this.id !== 'new' && val) this.loadProductData(val)
    }
  },
  async mounted () {
    if (this.id === 'new') {
      this.active = true
      return
    }
    if (this.productData) {
      this.loadProductData(this.productData)
      return
    }
    try {
      if (this.editFull && this.id && String(this.id).startsWith('produto-')) {
        const produtoId = String(this.id).replace('produto-', '')
        const p = await getProductGroupedById(produtoId)
        if (p) this.loadProductData(p)
      } else if (this.id) {
        const p = await getProductById(this.id)
        if (p) this.loadProductData(p)
      }
    } catch (e) {
      logger.error(e, this)
    }
  },
  methods: {
    loadProductData (data) {
      const p = data || this.productData
      if (!p) return
      this.active = p.active

      if (p.platform) this.platform = p.platform
      else if (p.pf) this.platform = 'profit'
      else if (p.ba) this.platform = 'blackarrow'
      else if (p.nj) this.platform = 'ninjatrader'
      else if (p.tv) this.platform = 'tradingview'

      this.desc = p.desc

      const formatExpiration = (exp) => exp && String(exp).includes('/')
        ? String(exp).split('/')[2] + '-' + String(exp).split('/')[1] + '-' + String(exp).split('/')[0]
        : exp || null

      if (this.editFull && p.periods && Array.isArray(p.periods) && p.periods.length > 0) {
        this.periods = p.periods.map(per => ({
          id: per.id,
          periodName: per.periodName || per.period_name || '',
          dias: per.dias != null ? parseInt(per.dias) : null,
          description: per.description || '',
          price: per.price != null ? per.price : '',
          priceUsd: per.priceUsd != null ? per.priceUsd : '',
          secondSubscriptionDiscount: per.secondSubscriptionDiscount != null ? parseInt(per.secondSubscriptionDiscount) : 0,
          promotion: per.promotion || false,
          type: per.type || 'percent',
          discount: per.discount,
          expiration: formatExpiration(per.expiration)
        }))
        this.initialPeriodIds = p.periods.map(per => per.id).filter(Boolean)
      } else {
        this.initialPeriodIds = []
        const expirationFormatted = formatExpiration(p.expiration)
        const periodName = p.name && p.name.includes(' - ')
          ? p.name.split(' - ').slice(1).join(' - ').trim()
          : p.name || ''
        this.periods = [{
          id: p.id,
          periodName,
          dias: p.dias != null ? parseInt(p.dias) : null,
          description: p.description || '',
          price: p.price != null ? p.price : '',
          priceUsd: p.priceUsd != null ? p.priceUsd : '',
          secondSubscriptionDiscount: p.secondSubscriptionDiscount != null ? parseInt(p.secondSubscriptionDiscount) : 0,
          promotion: p.promotion || false,
          type: p.type || 'percent',
          discount: p.discount,
          expiration: expirationFormatted
        }]
      }
    },
    addPeriod () {
      this.periods.push({
        periodName: '',
        dias: null,
        description: '',
        price: '',
        priceUsd: '',
        secondSubscriptionDiscount: 0,
        promotion: false,
        type: 'percent',
        discount: null,
        expiration: null
      })
    },
    removePeriod (index) {
      this.periods.splice(index, 1)
    },
    hasValidPrice (p) {
      const brl = this.parsePrice(p.price)
      const usd = this.parsePrice(p.priceUsd)
      return (brl != null && brl > 0) || (usd != null && usd > 0)
    },
    periodError (index, field) {
      const p = this.periods[index]
      if (!p) return false
      if (field === 'periodName') return !p.periodName || !p.periodName.trim()
      if (field === 'dias') return p.dias == null || p.dias <= 0
      if (field === 'price' || field === 'priceUsd') return !this.hasValidPrice(p)
      if (field === 'secondSubscriptionDiscount') {
        const v = p.secondSubscriptionDiscount
        if (v == null || v === '') return false
        return v < 0 || v > 100
      }
      return false
    },
    periodPromotionError (index, field) {
      const p = this.periods[index]
      if (!p || !p.promotion) return false
      if (field === 'discount') return p.discount == null || p.discount === ''
      if (field === 'expiration') return !p.expiration
      return false
    },
    getFormatMoney2 (index) {
      const p = this.periods[index]
      if (!p || p.type === 'fixed') {
        return { decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false }
      }
      return { decimal: '', thousands: '', prefix: '', suffix: ' %', precision: 0, masked: false }
    },
    setPeriodFormat (index) {
      const p = this.periods[index]
      if (p && p.type === 'percent' && (p.discount === null || typeof p.discount === 'number')) {
        // Force reactivity for money component
        this.$set(this.periods[index], 'discount', p.discount)
      }
    },
    validade (e) {
      e.preventDefault()
    },
    parsePrice (v) {
      if (v == null || v === '') return null
      const n = Number(v)
      if (!isNaN(n)) return n
      const s = String(v).replace(/\s/g, '').replace(/\./g, '').replace(',', '.')
      return parseFloat(s) || null
    },
    validate () {
      this.error = []
      if (!this.platform) this.error.push('platform')

      const validPeriods = this.periods.filter(p =>
        p.periodName && String(p.periodName).trim() && p.dias != null && p.dias > 0 && this.hasValidPrice(p)
      )
      if (validPeriods.length === 0) this.error.push('periods')

      for (const p of validPeriods) {
        if (p.secondSubscriptionDiscount == null || p.secondSubscriptionDiscount === '') {
          p.secondSubscriptionDiscount = 0
        } else if (p.secondSubscriptionDiscount < 0 || p.secondSubscriptionDiscount > 100) {
          this.error.push('periods')
          break
        }
        if (p.promotion && (!p.type || (p.discount == null || p.discount === '') || !p.expiration)) {
          this.error.push('periods')
          break
        }
      }

      return this.error.length === 0
    },
    async save () {
      if (this.loading) return
      if (!this.validate()) return

      this.loading = true
      this.error = []

      try {
        const validPeriods = this.periods.filter(p =>
          p.periodName && String(p.periodName).trim() && p.dias != null && p.dias > 0 && this.hasValidPrice(p)
        )

        if (this.id === 'new') {
          try {
            await create(
              this.platform,
              PLATFORM_LABELS[this.platform],
              this.desc || '',
              this.active,
              validPeriods
            )
          } catch (err) {
            const data = err.response ? err.response.data : {}
            if (data.error === 'Validation error' && data.fields && data.fields.includes('platform')) {
              this.error.push('platform_duplicate')
              this.loading = false
              return
            }
            throw err
          }
        } else if (this.editFull) {
          const name = PLATFORM_LABELS[this.platform]
          const produtoId = this.id && String(this.id).startsWith('produto-')
            ? String(this.id).replace('produto-', '')
            : null
          const validIds = new Set(validPeriods.filter(p => p.id).map(p => p.id))
          for (const id of this.initialPeriodIds) {
            if (!validIds.has(id)) {
              await remove(id)
            }
          }
          for (let i = 0; i < validPeriods.length; i++) {
            const period = validPeriods[i]
            if (period.id) {
              await update(
                period.id,
                this.platform,
                name,
                this.desc || '',
                this.active,
                period
              )
            } else if (produtoId) {
              const price = this.parsePrice(period.price) || 0
              const priceUsd = this.parsePrice(period.priceUsd)
              if (price > 0 || (priceUsd != null && priceUsd > 0)) {
                await addPeriod(produtoId, {
                  ...period,
                  price,
                  priceUsd: priceUsd != null ? priceUsd : null
                })
              }
            }
          }
        } else {
          const period = validPeriods[0]
          await update(
            this.id,
            this.platform,
            PLATFORM_LABELS[this.platform],
            this.desc || '',
            this.active,
            period
          )
        }

        this.loading = false
        this.$router.push('/product')
      } catch (err) {
        const data = err.response ? err.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields || []
        } else {
          logger.error(err, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.selector_change {
  background-color: #cccccc;
  color: #595959;
  font-size: 0.8em;
  padding: 2.5px;
}

.platform-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
}

.periods-list-scroll {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 8px;
  padding-right: 4px;
}

.periods-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.period-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
}
.period-row:last-of-type {
  margin-bottom: 0;
}
.period-row-desc {
  .period-name {
    flex: 1;
    min-width: 180px;
  }
  .period-dias {
    flex: 0 0 65px;
  }
}
.period-row-values {
  .period-price-wrapper {
    flex: 0 0 130px;
  }
  .period-remove {
    margin-left: auto;
  }
}
.period-row-second-discount {
  align-items: center;

  .period-field-label {
    flex: 0 0 auto;
    font-size: 0.85em;
    color: #595959;
    margin: 0;
  }

  .period-second-discount {
    flex: 0 0 90px;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;

    &.error {
      border-color: #c00;
    }
  }
}
.period-name {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;

  &.error {
    border-color: #c00;
  }
}

.period-dias {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.period-desc {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  width: 100%;
}

.period-price-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}
.period-currency-label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  min-width: 28px;
  margin: 0;
}

.period-price {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;

  &.error {
    border-color: #c00;
  }
}

.period-remove {
  padding: 8px 12px;
  border: none;
  background: #dc3545;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #c82333;
  }
}

.add-period-btn {
  margin-top: 12px;
  padding: 10px 16px;
  border: 2px dashed #007bff;
  background: transparent;
  color: #007bff;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #007bff;
    color: #fff;
  }
}

.period-block {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #eee;
}

.period-promotion {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ddd;
}

.period-promotion-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-top: 10px;
}

.switch-sm .text {
  font-size: 12px;
}

.discount-input {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  width: 120px;

  &.error {
    border-color: #c00;
  }
}

.expiration-input {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;

  &.error {
    border-color: #c00;
  }
}

.hint {
  color: #c00;
  font-size: 12px;
  margin-top: 4px;
}
</style>
